export default __webpack_public_path__ + "static/media/Monk's Belt of the Underworld.14228bdd.jpg";